import CardNote from "./CardNote";
import React, { useState, useEffect, useMemo } from 'react';
import { motion } from 'framer-motion';
import axiosInstance from '../../utils/axiosInstanse';
import Spiner from '../Spiner/Spiner';
import host from "../../host";
import './style.css';

function SignNote() {
  const [notes, setNotes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState('');

  const filteredData = useMemo(() => {
    if (search === '' || search === undefined) return notes;
    return notes.filter(item => {
      const itemValues = Object.values(item);
      return itemValues.some(value => String(value).includes(search));
    });
  }, [notes, search]);

  const normalData = (date) => {
    let [day, month, year] = date.split('.');
    if (day.length === 1) { day = '0' + day; }
    if (month.length === 1) { month = '0' + month; }
    return `${day}.${month}.${year}`;
  };

  useEffect(() => {
    axiosInstance.get(`${host}api/sign_notes/`)
      .then(response => {
        const new_data = response.data.map(item => {
          return {
            ...item,
            date: normalData(item.date)
          };
        });
        setNotes(new_data);
        setIsLoading(false);
      })
      .catch(error => {
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="sn-container">
      <motion.div
        initial={{ opacity: 0, y: -16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.12 }}
      >
        {isLoading ? (
          <Spiner />
        ) : notes.length > 0 ? (
          <>
            <div className="sn-search-wrap">
              <label className="sn-label" htmlFor="snSearch">
                Поиск
              </label>
              <input
                id="snSearch"
                type="text"
                className="sn-input"
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="Введите текст для поиска..."
              />
              <div className="sn-hint">Введите критерии поиска</div>
            </div>

            {filteredData.map(note => <CardNote key={note.id} note={note} />)}

            <div style={{ marginBottom: 70 }}></div>
          </>
        ) : (
          <div className="sn-empty">Нет записей</div>
        )}
      </motion.div>
    </div>
  );
}

export default SignNote;